import * as React from 'react';
import { ReactNode } from 'react';
import { Hierarchy, HierarchyApi } from '../../api/core';
import { HierarchyToolTip } from './HierarchyToolTip';

interface Props {
  idx: string;
  id: string;
  children: ReactNode;
}

export const ProjectHierarchyToolTip: React.FC<Props> = (props: Props): ReactNode => {
  const [hierarchy, setHierarchy]
    = React.useState<Hierarchy[]>(null);

  const load = async (): Promise<void> => {
    if (hierarchy) return;
    try {
      const api: HierarchyApi = new HierarchyApi();
      const result: Hierarchy[] = await api.getProjectHierarchy({projectId: parseInt(props.id, 10)});
      setHierarchy(result || []);
    } catch (error) {
      setHierarchy([]);
    }
  };

  return (<HierarchyToolTip idx={props.idx} hierarchy={hierarchy} onBeforeShow={load} children={props.children}
                            path={'project'}/>);
};
